'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../button/index.js');
var buttonIcon_model = require('../button/button-icon.model.js');
var buttonCheckbox_model = require('../button/button-checkbox.model.js');
var buttonSeparator_model = require('../button/button-separator.model.js');

/**
 * Toolbar configurations.
 *
 * @export
 * @interface ToolbarConfig
 */

/**
 * Console toolbar buttons.
 *
 * @export
 * @enum {number}
 */
var ConsoleToolbarButton = /*#__PURE__*/function (ConsoleToolbarButton) {
  ConsoleToolbarButton[ConsoleToolbarButton["Expand"] = 0] = "Expand";
  ConsoleToolbarButton[ConsoleToolbarButton["Schema"] = 1] = "Schema";
  ConsoleToolbarButton[ConsoleToolbarButton["Graph"] = 2] = "Graph";
  ConsoleToolbarButton[ConsoleToolbarButton["Json"] = 3] = "Json";
  ConsoleToolbarButton[ConsoleToolbarButton["Table"] = 4] = "Table";
  ConsoleToolbarButton[ConsoleToolbarButton["Problems"] = 5] = "Problems";
  return ConsoleToolbarButton;
}({});

/**
 * Pattern toolbar buttons.
 *
 * @export
 * @enum {number}
 */
var PatternToolbarButton = /*#__PURE__*/function (PatternToolbarButton) {
  PatternToolbarButton[PatternToolbarButton["Save"] = 0] = "Save";
  PatternToolbarButton[PatternToolbarButton["SaveAs"] = 1] = "SaveAs";
  PatternToolbarButton[PatternToolbarButton["GSQL"] = 2] = "GSQL";
  PatternToolbarButton[PatternToolbarButton["Console"] = 3] = "Console";
  PatternToolbarButton[PatternToolbarButton["ConfigPanel"] = 4] = "ConfigPanel";
  PatternToolbarButton[PatternToolbarButton["ViewOptions"] = 5] = "ViewOptions";
  PatternToolbarButton[PatternToolbarButton["Run"] = 6] = "Run";
  PatternToolbarButton[PatternToolbarButton["Separator1"] = 7] = "Separator1";
  PatternToolbarButton[PatternToolbarButton["Undo"] = 8] = "Undo";
  PatternToolbarButton[PatternToolbarButton["Redo"] = 9] = "Redo";
  PatternToolbarButton[PatternToolbarButton["Edit"] = 10] = "Edit";
  PatternToolbarButton[PatternToolbarButton["Copy"] = 11] = "Copy";
  PatternToolbarButton[PatternToolbarButton["Delete"] = 12] = "Delete";
  PatternToolbarButton[PatternToolbarButton["Separator2"] = 13] = "Separator2";
  PatternToolbarButton[PatternToolbarButton["PatternVertex"] = 14] = "PatternVertex";
  PatternToolbarButton[PatternToolbarButton["PatternEdge"] = 15] = "PatternEdge";
  PatternToolbarButton[PatternToolbarButton["Pick"] = 16] = "Pick";
  PatternToolbarButton[PatternToolbarButton["Merge"] = 17] = "Merge";
  PatternToolbarButton[PatternToolbarButton["PatternView"] = 18] = "PatternView";
  PatternToolbarButton[PatternToolbarButton["Separator3"] = 19] = "Separator3";
  PatternToolbarButton[PatternToolbarButton["Widget"] = 20] = "Widget";
  PatternToolbarButton[PatternToolbarButton["Filter"] = 21] = "Filter";
  PatternToolbarButton[PatternToolbarButton["Attachment"] = 22] = "Attachment";
  PatternToolbarButton[PatternToolbarButton["OrderBy"] = 23] = "OrderBy";
  PatternToolbarButton[PatternToolbarButton["Limit"] = 24] = "Limit";
  PatternToolbarButton[PatternToolbarButton["Output"] = 25] = "Output";
  return PatternToolbarButton;
}({});

/**
 * Pattern widget buttons.
 *
 * @export
 * @enum {number}
 */
var PatternWidgetButton = /*#__PURE__*/function (PatternWidgetButton) {
  PatternWidgetButton[PatternWidgetButton["Intersect"] = 0] = "Intersect";
  PatternWidgetButton[PatternWidgetButton["Union"] = 1] = "Union";
  PatternWidgetButton[PatternWidgetButton["Subtract"] = 2] = "Subtract";
  PatternWidgetButton[PatternWidgetButton["Within"] = 3] = "Within";
  PatternWidgetButton[PatternWidgetButton["ShortestPath"] = 4] = "ShortestPath";
  PatternWidgetButton[PatternWidgetButton["None"] = 5] = "None";
  return PatternWidgetButton;
}({});

// How many input patterns each widget takes.
var PatternWidgetInputNumber = [2, 2, 2, 1, 2];

// How many output patterns each widget produces.
var PatternWidgetOutputNumber = [1, 1, 1, 1, 0];

/**
 * Console toolbar configurations.
 *
 * @export
 * @returns {ToolbarConfig}
 */
function getConsoleToolbarConfig() {
  return {
    asTab: true,
    left: [new buttonIcon_model.IconButton({
      key: 'expand',
      icon: 'fullscreen',
      tooltip: 'Expand',
      tooltipPosition: 'right'
    }), new buttonIcon_model.IconButton({
      key: 'schema',
      icon: 'schema',
      tooltip: 'Graph schema',
      tooltipPosition: 'right'
    }), new buttonIcon_model.IconButton({
      key: 'graph',
      icon: 'graph',
      tooltip: 'Visualize graph result',
      tooltipPosition: 'right'
    }), new buttonIcon_model.IconButton({
      key: 'json',
      icon: 'json',
      tooltip: 'View JSON result',
      tooltipPosition: 'right'
    }), new buttonIcon_model.IconButton({
      key: 'table',
      icon: 'table',
      tooltip: 'View table result',
      tooltipPosition: 'right'
    }), new buttonIcon_model.IconButton({
      key: 'problems',
      icon: 'error',
      tooltip: 'Problems',
      tooltipPosition: 'right'
    })]
  };
}

/**
 * Pattern toolbar configurations.
 *
 * @export
 * @param {Map<string, any>} dataModels
 * @returns {ToolbarConfig}
 */
function getPatternToolbarConfig(dataModels) {
  return {
    top: [new buttonIcon_model.IconButton({
      key: 'save',
      icon: 'save',
      tooltip: 'Save the graph pattern',
      disabled: true
    }), new buttonIcon_model.IconButton({
      key: 'saveAs',
      icon: 'save-as',
      tooltip: 'Save the graph pattern with a different name',
      disabled: true
    }), new buttonIcon_model.IconButton({
      key: 'gsql',
      icon: 'gsql',
      tooltip: 'Save as a GSQL query',
      disabled: true
    }), new buttonIcon_model.IconButton({
      key: 'console',
      icon: 'video_label',
      tooltip: 'Console'
    }), new buttonIcon_model.IconButton({
      key: 'configPanel',
      icon: 'list',
      tooltip: 'Configuration panel',
      disabled: true
    }), new buttonIcon_model.IconButton({
      key: 'viewOptions',
      icon: 'view-options',
      tooltip: 'Render pattern options',
      disabled: true,
      menu: [new buttonCheckbox_model.CheckboxButton({
        key: 'patternDetail',
        label: 'Pattern detail',
        model: dataModels.get('patternDetail')
      }), new buttonCheckbox_model.CheckboxButton({
        key: 'patternAddOn',
        label: 'Pattern add-on',
        model: dataModels.get('patternAddOn')
      }), new buttonCheckbox_model.CheckboxButton({
        key: 'outputGlow',
        label: 'Output glow',
        model: dataModels.get('outputGlow')
      })]
    }), new buttonIcon_model.IconButton({
      key: 'run',
      icon: 'play_arrow',
      tooltip: 'Run',
      disabled: true
    }), new buttonSeparator_model.SeparatorButton(), new buttonIcon_model.IconButton({
      key: 'undo',
      icon: 'undo',
      tooltip: 'Undo',
      disabled: true
    }), new buttonIcon_model.IconButton({
      key: 'redo',
      icon: 'redo',
      tooltip: 'Redo',
      disabled: true
    }), new buttonIcon_model.IconButton({
      key: 'edit',
      icon: 'edit',
      tooltip: 'Edit',
      disabled: true
    }), new buttonIcon_model.IconButton({
      key: 'copy',
      icon: 'content_copy',
      tooltip: 'Duplicate selected patterns',
      disabled: true
    }), new buttonIcon_model.IconButton({
      key: 'delete',
      icon: 'delete',
      tooltip: 'Delete',
      disabled: true
    }), new buttonSeparator_model.SeparatorButton(), new buttonIcon_model.IconButton({
      key: 'addPatternVertex',
      icon: 'add_circle',
      tooltip: 'Add a vertex pattern',
      disabled: true
    }), new buttonIcon_model.IconButton({
      key: 'addPatternEdge',
      icon: 'trending_flat',
      tooltip: 'Add an edge pattern',
      disabled: true
    }), new buttonIcon_model.IconButton({
      key: 'pick',
      icon: 'pick',
      tooltip: 'Pick',
      disabled: true
    }), new buttonIcon_model.IconButton({
      key: 'merge',
      icon: 'merge',
      tooltip: 'Merge',
      disabled: true
    }), new buttonIcon_model.IconButton({
      key: 'addPatternView',
      icon: 'pattern-view',
      tooltip: 'Add a pattern view',
      disabled: true
    }), new buttonSeparator_model.SeparatorButton(), new buttonIcon_model.IconButton({
      key: 'widget',
      icon: 'extension',
      tooltip: 'Widget',
      disabled: true,
      menu: [new buttonIcon_model.IconButton({
        key: 'intersect',
        icon: 'intersect',
        label: 'Intersect'
      }), new buttonIcon_model.IconButton({
        key: 'union',
        icon: 'union',
        label: 'Union'
      }), new buttonIcon_model.IconButton({
        key: 'subtract',
        icon: 'subtract',
        label: 'Subtract'
      }), new buttonIcon_model.IconButton({
        key: 'within',
        icon: 'within',
        label: 'Within'
      })
      // new IconButton({
      //   key: 'shortest-path',
      //   icon: 'shortest-path',
      //   label: 'Shortest Path'
      // }),
      ]
    }),
    // new IconButton({
    //   key: 'deny',
    //   icon: 'deny',
    //   tooltip: 'Not exist',
    //   disabled: true
    // }),
    new buttonIcon_model.IconButton({
      key: 'filter',
      icon: 'filter',
      tooltip: 'Filter',
      disabled: true
    }), new buttonIcon_model.IconButton({
      key: 'attachment',
      icon: 'aggregation',
      tooltip: 'attachment',
      disabled: true
    }), new buttonIcon_model.IconButton({
      key: 'order',
      icon: 'order',
      tooltip: 'Order by',
      disabled: true
    }), new buttonIcon_model.IconButton({
      key: 'limit',
      icon: 'limit',
      tooltip: 'Limit',
      disabled: true
    }), new buttonIcon_model.IconButton({
      key: 'output',
      icon: 'output',
      tooltip: 'In result',
      disabled: true
    }), new buttonSeparator_model.SeparatorButton(), new buttonIcon_model.IconButton({
      key: 'patternVisInfo',
      icon: 'description',
      tooltip: 'Show visual pattern information',
      disabled: true
    })]
  };
}

/**
 * Pattern chart configurations.
 *
 * @export
 * @returns {GraphChartSetting}
 */
function getPatternChartConfig() {
  return {
    advanced: {
      hideArrorMinZoom: 0.1
    },
    render: {
      info: {
        enabled: false
      },
      style: {
        selfLinkHeightFactor: 4,
        fadeTime: 0
      }
    }
  };
}

/**
 * Schema chart configurations.
 *
 * @export
 * @returns {GraphChartSetting}
 */
function getSchemaChartConfig() {
  return {
    render: {
      style: {
        selfLinkHeightFactor: 7
      },
      interaction: {
        nodesMovable: false
      }
    }
  };
}

/**
 * Json viewer configurations.
 *
 * @export
 * @returns {EditorConfiguration}
 */
function getJsonViewerConfig() {
  return {
    readOnly: true,
    cursorHeight: 0,
    mode: 'application/json',
    tabindex: -1,
    autofocus: false
  };
}

exports.ConsoleToolbarButton = ConsoleToolbarButton;
exports.PatternToolbarButton = PatternToolbarButton;
exports.PatternWidgetButton = PatternWidgetButton;
exports.PatternWidgetInputNumber = PatternWidgetInputNumber;
exports.PatternWidgetOutputNumber = PatternWidgetOutputNumber;
exports.getConsoleToolbarConfig = getConsoleToolbarConfig;
exports.getJsonViewerConfig = getJsonViewerConfig;
exports.getPatternChartConfig = getPatternChartConfig;
exports.getPatternToolbarConfig = getPatternToolbarConfig;
exports.getSchemaChartConfig = getSchemaChartConfig;
